<div class="mb-5">
  <mb-products-teaser-component
    [references$]="references$"
    [title]="title"
    [dataAnalyticsClickSource]="dataAnalyticsClickSource"
    [dataAnalyticsEventLabel]="dataAnalyticsEventLabel"
  ></mb-products-teaser-component>
</div>
